import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import GamesSection from "./components/GamesSection";
import GuildsSection from "./components/GuildsSection";
export default function GamesGuildsPage() {
  return (
    <div className="bg-[#080808] min-h-screen" style={{ fontFamily: "'Inter', sans-serif" }}>
      <Navbar />
      <section className="relative pt-36 pb-20 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://public.readdy.ai/ai/img_res/1b95fb913aab0b6fd359304d605972e0.jpg"
            alt="AWWAL Games and Guilds"
            className="w-full h-full object-cover object-top opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-[#080808]/80 via-[#080808]/50 to-[#080808]" />
        </div>
        <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 border border-[#00ff88]/30 rounded-sm bg-[#00ff88]/5 mb-8">
            <span className="w-1.5 h-1.5 rounded-full bg-[#00ff88] animate-pulse" />
            <span className="text-[#00ff88] text-xs tracking-[0.3em] uppercase font-semibold font-inter">Games & Guilds</span>
          </div>
          <h1 className="text-5xl lg:text-7xl font-black text-white tracking-tight leading-none mb-6 max-w-3xl font-syne">
            Play. Compete.<br /><span className="text-[#00ff88]">Dominate.</span>
          </h1>
          <p className="text-white/45 text-lg max-w-2xl leading-relaxed font-inter">
            Explore AWWAL's universe of games and join elite guilds that are redefining competitive gaming in Southeast Asia and beyond.
          </p>
        </div>
      </section>
      <GamesSection />
      <GuildsSection />
      <Footer />
    </div>
  );
}
